import * as cheerio from 'cheerio';
import { getSessionClient } from '../modules/sessionClient';
import { isJSON } from '../helpers/utils';
import { getTranslationParser } from './translationParser';
export let variableParser = null;
export const createVariableParser = (variableParserConfig) => {
    const sessionClient = getSessionClient();
    const translationParser = getTranslationParser();
    const parse = async (rawValue) => {
        let parsedValue = rawValue;
        if (rawValue) {
            const htmlDoc = cheerio.load(rawValue);
            const body = htmlDoc.root().find('body');
            const elements = body.find('.mention');
            for (const element of elements) {
                const variableId = cheerio.default(element).data('mention-id');
                const variableType = cheerio.default(element).data('variable-type');
                let variableValue = '';
                if (variableType === 'translation-key') {
                    variableValue = await translationParser.parse(variableId);
                }
                else {
                    const [sessionValue] = await sessionClient.read(variableId);
                    variableValue = await variableParserConfig.processValue({
                        reference: variableId,
                        value: sessionValue
                    });
                }
                if (variableValue === undefined) {
                    variableValue = '';
                }
                else {
                    if (!isJSON(variableValue) && variableValue.startsWith('{"')) {
                        const innerValue = variableValue.replace('{"', '').replace('"}', '').trim();
                        if (innerValue.split(',').length === 1) {
                            variableValue = innerValue;
                        }
                    }
                }
                // escape $ symbols (if any) as they are treated as special symbols by the .replace method (Refer: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#specifying_a_string_as_the_replacement)
                if (variableValue.includes('$')) {
                    variableValue = variableValue.replaceAll('$', '$$$$');
                }

                // decode back all angle brackets (due to security changes in prosemirror editor, html attributes are also encoded now, unlike earlier)
                let searchValue = cheerio.default(element).wrap('<span>').parent().html();
                parsedValue = parsedValue.replaceAll(' &gt; ', ' > ');
                searchValue = searchValue ? searchValue.replaceAll(' &gt; ', ' > ') : '';

                parsedValue = parsedValue.replace(searchValue, variableValue);
                parsedValue = parsedValue.trim();
            }
        }
        return parsedValue;
    };
    const extractReferenceId = (rawValue) => {
        if (rawValue) {
            const htmlDoc = cheerio.load(rawValue);
            const body = htmlDoc.root().find('body');
            const elements = body.find('.mention');
            const referenceId = elements ? cheerio.default(elements[0]).data('mention-id') : null;
            return referenceId;
        }
        return null;
    };
    variableParser = {
        parse,
        extractReferenceId,
        ...variableParserConfig
    };
    return getVariableParser();
};
export const getVariableParser = () => {
    if (variableParser === null) {
        throw '@nuclicore/core: variable parser is not configured';
    }
    return variableParser;
};
